import { Message } from "@/types";
import { ENV, LocalStorageService } from "@/utils";
import { io, Socket } from "socket.io-client";

export const socket: Socket<ServerToClientEvents> = io(
  ENV.VITE_BACKEND_API_URL,
  {
    autoConnect: false,
  }
);
export const connectChatSocket = () => {
  socket.io.opts.extraHeaders = {
    authorization: `Bearer ${LocalStorageService.getSupportAccessToken()}`,
  };
  socket.connect();
};

type ServerToClientEvents = {
  "message-created": MessageCreatedEvent;
  "message-updated": MessageUpdatedEvent;
};

type MessageCreatedEvent = (message: Message) => void;
type MessageUpdatedEvent = ({
  isReadByMeChanged,
  isReadChanged,
  message,
  unreadMessages,
}: {
  isReadByMeChanged: boolean;
  isReadChanged: boolean;
  message: Message;
  unreadMessages?: Message[];
}) => void;
